import React from 'react';
import twMerge from 'utilities/src/twMerge';
import { type IOptions } from '../../../utils/options';
import IconComponent from '../../../../../Icon';
import CheckboxIcon from './_CheckboxIcon';
import { IOptionProps } from '../_props';
import Label from './_Label';

type ItemProps = {
  option: IOptions;
  index: number;
  getItemProps: IOptionProps['getItemProps'];
  highlightedIndex: IOptionProps['highlightedIndex'];
  selectedItems: IOptionProps['selectedItems'];
  inputValue: IOptionProps['inputValue'];
  highlightOptions: IOptionProps['highlightOptions'];
  highlightIndexes: number[];
  optionThemeClasses: string;
  optionActiveThemeClasses: string;
  optionSelectedThemeClasses: string;
  optionHighlightedTextThemeClasses: string;
  optionIconThemeClasses: string;
  style?: React.CSSProperties;
};

export default function Item({
  option,
  index,
  getItemProps,
  highlightedIndex,
  selectedItems,
  inputValue,
  highlightOptions,
  highlightIndexes,
  optionThemeClasses,
  optionActiveThemeClasses,
  optionSelectedThemeClasses,
  optionHighlightedTextThemeClasses,
  optionIconThemeClasses,
  style,
}: ItemProps) {
  return (
    <li
      data-testid={`option-${option.value}`}
      className={twMerge(
        optionThemeClasses,
        highlightedIndex === index && optionActiveThemeClasses,
        selectedItems.some((item: any) => item.value === option.value) && optionSelectedThemeClasses,
      )}
      {...getItemProps({ item: option, index })}
      style={style}
    >
      <CheckboxIcon value={option.value} selectedItems={selectedItems} />
      <Label
        highlightOptions={highlightOptions}
        inputValue={inputValue}
        highlightIndexes={highlightIndexes}
        index={index}
        option={option}
        optionHighlightedTextThemeClasses={optionHighlightedTextThemeClasses}
      />
      <IconComponent iconName={option.icon} size="IconS" className={optionIconThemeClasses} />
    </li>
  );
}
